<div class="sidebar">
  <div class="sidebar-header">
    <div class="logo">
      <mat-icon class="logo-icon">local_parking</mat-icon>
      <span class="logo-text gradient-text">Urbix</span>
    </div>
    <div class="subtitle">Admin Console</div>
  </div>

  <mat-divider></mat-divider>

  <nav class="sidebar-nav">
    <mat-nav-list>
      @for (item of menuItems; track item.route) {
        <a mat-list-item 
           [routerLink]="item.route" 
           routerLinkActive="active"
           class="nav-item">
          <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          <span matListItemTitle>{{ item.label }}</span>
          @if (item.badge) {
            <span class="badge">{{ item.badge }}</span>
          }
        </a>
      }
    </mat-nav-list>
  </nav>

  <div class="sidebar-footer">
    <div class="project-info">
      <mat-icon>info</mat-icon>
      <div>
        <strong>ТРЦ Ocean Plaza</strong><br>
        <small>Київ, вул. Антоновича</small>
      </div>
    </div>
  </div>
</div>
